import { estMonteeDansShell } from '@/utils/modeLancement';

// URL du navigateur, pour les redirections
// En accès direct (URL propre de l'application, hors shell 360), les routes sont à la racine.

const domain = '/facturation';
const product = '/regie';

const baseUrl =
  process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test' || !estMonteeDansShell()
    ? ''
    : `${domain}${product}`;

export default baseUrl;
